import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../../../context/AuthContext';
import PolicyRulesPanel, { TARGET, TARGET_TYPE_ORDER } from '../../../components/ui/PolicyRulesPanel';
import { previewImpact } from '../../../services/approvalFlowService';

// Kişi hedefi yok: kişiye özel atama "Kişiye Özel" sekmesindedir (tek depo — spec 2026-11-01 §4.2).
const RULE_TARGET_TYPES = TARGET_TYPE_ORDER.filter((tt) => tt !== TARGET.PERSON);

/**
 * "Kurallar" sekmesi — onay akışının canlı atama kuralları (departman / ekip / lokasyon / grup / statü / alt şirket /
 * şirket). Kural tutan herkes talebinde bu akışla ilerler; ekibin kuralı üst departmanınkini ezer, kişiye özel atama
 * her kuralı ezer. Kayıt ve silme öncesi "kimin akışı değişir?" önizlemesi gösterilir. Yazma: EM.Write.
 */
export default function FlowRulesTab({ flowId, flowType, onChanged }) {
  const { t } = useTranslation();
  const { canWrite } = useAuth();
  const kind = `approvalFlow.${flowType}`;

  const impactPreview = useCallback((change) => {
    const body = { flowType };
    if (change.action === 'create') body.addRule = change.body;
    if (change.action === 'update') {
      body.updateRuleId = change.ruleId;
      body.updateRule = change.body;
    }
    if (change.action === 'delete') body.deleteRuleId = change.ruleId;
    return previewImpact(body);
  }, [flowType]);

  const targetTypes = useMemo(() => RULE_TARGET_TYPES, []);

  return (
    <PolicyRulesPanel
      kind={kind}
      policyId={flowId}
      title={t('approvalFlow.rulesTitle')}
      canWrite={canWrite('EM')}
      targetTypes={targetTypes}
      departmentPathLabels
      impactPreview={impactPreview}
      onChanged={onChanged}
    />
  );
}
